export default function (app) {

    var TOKEN_LENGHT = 128;

    app.run(['Restangular', '$cookies', 'AUTH_TOKEN_NAME','$location',
        function run(Restangular, $cookies, AUTH_TOKEN_NAME, $location) {
            var token, lang;
            if (!(token = $cookies.get(AUTH_TOKEN_NAME))) {
                token = require("randomstring").generate(TOKEN_LENGHT);
                $cookies.put(AUTH_TOKEN_NAME, token);
            }
            
            Restangular.setDefaultHeaders({
                'Kts-Authorization': token,
                'Content-Type': 'application/json'
            });
            
            Restangular.setErrorInterceptor(function (response, deferred, responseHandler) {
                    if (response.status === 401) {
                        $location.path('/login');
                        return false; // error handled
                    }
                    return true; // error not handled
                });
        }]);

    app.service('Auth', ['Restangular', '$cookies', 'AUTH_TOKEN_NAME','AUTH_LANG_NAME','$translate'
        , function (Restangular, $cookies, AUTH_TOKEN_NAME,AUTH_LANG_NAME, $translate) {

            var session = {
                user: {},
                isLoading: false
            };


            session.isLoading = true;
            Restangular.one('web/login').get().then(function (user) {
                session.isLoading = false;
                if (user && user.id && user.tags.user_role && user.tags.user_role.indexOf('admin') !== -1) {
                    session.user = user;
                }
            });

            this.logout = function () {
                session.user = {};

                var token = require("randomstring").generate(TOKEN_LENGHT);
                $cookies.put(AUTH_TOKEN_NAME, token);

                Restangular.setDefaultHeaders({
                    'Kts-Authorization': token,
                    'Content-Type': 'application/json'
                });
            };

            this.getAuthToken = function() {
                return $cookies.get(AUTH_TOKEN_NAME);
            };

            this.isLoggedIn = function () {
                return !!session.user.id;
            };
            
            this.isLoading = function () {
                return !!session.isLoading;
            };

            this.setUser = function (user) {
                session.user = user;
            };

            this.getUser = function () {
                return session.user;
            };
            
            this.refresh = function () {
                Restangular.one('web/login').get().then(function (user) {
                    session.isLoading = false;
                    if (user && user.id && user.tags.user_role && user.tags.user_role.indexOf('admin') !== -1) {
                        session.user = user;
                    }
                });
            };

            this.getLanguage = function () {
                return session.language;
            };
        }]);
    
    app.controller('KtsAdminLoginController', ['$scope', 'Restangular', 'Auth','$location', 
        function ($scope, Restangular, Auth,$location) {

            this.login = function (email, password) {
                Restangular.one('web/login').customPOST({
                    email: email,
                    password: password
                }).then(function (user) {
                    if (user && user.id && user.tags.user_role && user.tags.user_role.indexOf('admin') !== -1) {
                        Auth.setUser(user);
                        $location.path('/dashboard');
                    }
                }, function (response) {});
            };

        }]);
    
}





// WEBPACK FOOTER //
// ./js/auth/index.js